import { Tag } from 'antd';
import styled from 'styled-components';

import { Icon } from '../Icon';

export const IconWrapper = styled.div<{ $borderColor: string; $backgroundColor: string }>`
  width: fit-content;
  display: flex;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

export const StyledTag = styled(Tag)<{ $borderColor: string; $backgroundColor: string }>`
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

export const StyledIcon = styled(Icon)<{ $color: string }>`
  color: ${({ $color }) => $color};
`;

export const TextWrapper = styled.div<{ $color: string }>`
  font-weight: 600;
  color: ${({ $color }) => $color};
`;
